import { createFileRoute } from "@tanstack/react-router";
import { AdminShell } from "@/components/admin/AdminShell";
import { AdminDashboard } from "@/components/admin/pages";
import { requireAdmin } from "@/lib/require-admin";

export const Route = createFileRoute("/admin")({
  beforeLoad: () => {
    requireAdmin();
  },
  component: () => (
    <AdminShell page="dashboard">
      <AdminDashboard />
    </AdminShell>
  ),
});
